import * as React from 'react';
import { Outlet, ScrollRestoration } from 'react-router-dom';
import { Box } from '@mui/material';
import Navigation from '../../components/navigation';
import OryxDeploymentNotifier from '../../components/deployment-notifier';

type Props = {
  hideNav?: boolean;
};

const LayoutWrapper = ({
  hideNav = false,
}: Props) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
    }}
  >
    <ScrollRestoration />
    {hideNav ? null : <Navigation />}
    <OryxDeploymentNotifier />
    <Box
      component="main"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
      }}
    >
      <Outlet />
    </Box>
  </Box>
);

export default LayoutWrapper;
